export default function (state = [], action) {
    switch (action.type) {
        case "STYLING_SELECTED":
            return action.payload;
        default:
            return state;
    }
}